<template>
  <div class="divider-container">
    <div
      v-if="spaceForLogo"
      class="logo-box"
    />

    <div class="divider-cell">
      <el-divider content-position="center">
        {{ columnLabel01 }}
      </el-divider>
    </div>

    <div class="divider-cell">
      <el-divider content-position="center">
        {{ columnLabel02 }}
      </el-divider>
    </div>

    <div class="divider-cell">
      <el-divider content-position="center">
        {{ columnLabel03 }}
      </el-divider>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class extends Vue {
  @Prop({ required: false, default: true }) private spaceForLogo?: boolean
  @Prop({ required: false }) private columnLabel01?: number
  @Prop({ required: false }) private columnLabel02?: string
  @Prop({ required: false }) private columnLabel03?: string
}
</script>

<style lang="scss">
.divider-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: fit-content;
  font-size: 1vw;
  .divider-cell {
    display: flex;
    flex: 1;
    padding: 0 10px 0 10px;
    .el-divider {
      background-color: hsl(215, 30%, 45%);
      margin: 5px auto 5px auto;
      .el-divider__text {
        border: 0;
        padding: 0 5px 0 5px;
        font-size: 0.8em;
        font-weight: bold;
        color: hsl(215, 30%, 45%);
        white-space: nowrap;
      }
    }
  }
}

@media only screen and (max-width: 1199px) {
  .chart-statistics {
    .logo-box {
      width: 10% !important;
      min-width: 10% !important;
    }
  }
}
</style>
